
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/roadtrip5x",
      function () {
        return require("private-next-pages/roadtrip5x.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/roadtrip5x"])
      });
    }
  